<script lang="ts">
  import Icon from 'shared/javascripts/components/Icon.svelte'
  import HeaderMenu from './HeaderMenu.svelte'
  import UserMenuItems from './UserMenuItems.svelte'
  import { isMenuLink, type UserMenuEntry } from './user_menu'
  import { menuHasCurrentPath } from 'frontend/inertia/util/currentPath'
  import menuIcon from 'shared/images/icons/menu.svg'

  let {
    items,
    currentPath,
    align = 'center',
    compact = false,
  }: {
    items: UserMenuEntry[]
    currentPath: string
    align?: 'center' | 'right'
    compact?: boolean
  } = $props()
</script>

<!-- tracking: navigation.menu_toggle -->
<HeaderMenu
  label="Menü"
  {align}
  current={menuHasCurrentPath(items.filter(isMenuLink), currentPath)}
  tracking={{ id: 'navigation.menu_toggle' }}
>
  {#snippet trigger()}
    <Icon src={menuIcon} size="large" />
    {#if compact}
      <span class="visually-hidden">Menü</span>
    {:else}
      <span>Menü</span>
    {/if}
  {/snippet}

  {#snippet children({ close })}
    <UserMenuItems {items} {close} {currentPath} />
  {/snippet}
</HeaderMenu>
